"use strict";

require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.from.js");
require("core-js/modules/es.array.is-array.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.object.define-properties.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.weak-map.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PasswordForm = void 0;
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.array.join.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.date.to-json.js");
require("core-js/modules/es.date.to-string.js");
require("core-js/modules/es.function.bind.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.object.values.js");
require("core-js/modules/es.regexp.constructor.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.string.trim.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/web.timers.js");
require("core-js/modules/web.url.js");
require("core-js/modules/web.url.to-json.js");
require("core-js/modules/web.url-search-params.js");
var _forms = require("@mozaic-ds/freemarker/js/modules/_forms.js");
require("whatwg-fetch");
var es6promise = _interopRequireWildcard(require("es6-promise"));
require("formdata-polyfill");
require("classlist-polyfill");
var _genericalLoader = _interopRequireDefault(require("integration-web-core--socle/js/assets/modules/_genericalLoader.class"));
var tools = _interopRequireWildcard(require("@mozaic-ds/freemarker/js/utilities/_tools.js"));
var _field = _interopRequireDefault(require("@mozaic-ds/freemarker/js/tokens/field.json"));
var _tms = require("integration-web-core--socle/js/assets/commons/_tms.js");
var _trackingEvents = require("./trackingEvents");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
// WORKAROUND remove customer from context when entering login form
sessionStorage && sessionStorage.removeItem && sessionStorage.removeItem('customerSpaceAdminCustomerNumber');
var AUTH_TYPE = {
  CLIENT: "CLIENT",
  COLLAB: "COLLAB",
  CLIENT_COLLAB: "CLIENT_COLLAB"
};
var signInPath = '/identity/v1/password/login';
var callbackPath = '/identity/v1/password/callback';
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = function (callback, thisArg) {
    thisArg = thisArg || window;
    for (var i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}
function cleanNotifications() {
  var notifications = document.querySelectorAll('.js-notification');
  var _iterator = _createForOfIteratorHelper(notifications),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var notification = _step.value;
      notification.classList.add('kl-hidden');
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}
function debounce(func) {
  var _this = this;
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
  var timer;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    clearTimeout(timer);
    timer = setTimeout(function () {
      func.apply(_this, args);
    }, timeout);
  };
}
function setupEmailValidation(emailField) {
  var regexPattern = emailField.getAttribute('pattern');
  if (!regexPattern) {
    console.error('The email field is missing a valid pattern attribute.');
    return;
  }
  var regex = new RegExp(regexPattern);
  function validateEmailField() {
    var fieldValue = emailField.value.trim();
    if (!fieldValue) {
      _initInputValidation(emailField);
    } else if (regex.test(fieldValue)) {
      _inputCorrect(emailField);
    } else {
      _inputIncorrect(emailField);
    }
  }
  _addValidationListeners(emailField, validateEmailField);
}
function setupPasswordValidation(passwordContainer) {
  var passwordInput = passwordContainer.querySelector('input');
  var passwordButton = passwordContainer.querySelector('button');
  if (!passwordInput || !passwordButton) {
    console.error('Password container is missing required elements.');
    return;
  }
  function validatePasswordField() {
    var fieldValue = passwordInput.value.trim();
    var isValid = fieldValue.length > 0;
    if (isValid) {
      markElementsAsCorrect([passwordInput, passwordButton, passwordContainer]);
    } else {
      resetValidationState([passwordInput, passwordButton, passwordContainer]);
    }
  }
  function markElementsAsCorrect(elements) {
    elements.forEach(function (element) {
      return _inputCorrect(element);
    });
  }
  function resetValidationState(elements) {
    elements.forEach(function (element) {
      return _initInputValidation(element);
    });
  }
  _addValidationListeners(passwordInput, validatePasswordField);
}
function _addValidationListeners(field, validationFn) {
  var events = ['input', 'blur', 'change', 'focus'];
  events.forEach(function (event) {
    return field.addEventListener(event, validationFn);
  });
}
function _initInputValidation(field) {
  field.classList.remove('is-invalid', 'is-valid');
}
function _inputCorrect(field) {
  field.classList.remove('is-invalid');
  field.classList.add('is-valid');
  _hideErrorMsg(field);
}
function _inputIncorrect(field) {
  field.classList.remove('is-valid');
  field.classList.add('is-invalid');
}
function _turnInvalid(field, message) {
  _inputIncorrect(field);
  _manageErrorMsg(field, message);
}
function _manageErrorMsg(field, message) {
  var fieldContainer = tools.getClosest(field, ".".concat(_field["default"]["class"]));
  var errorMsg = fieldContainer.querySelector('.js-form-error');
  if (errorMsg) {
    field.removeAttribute('aria-describedby');
    fieldContainer.removeChild(errorMsg);
  }
  field.insertAdjacentHTML('afterend', _makeError(field, message));
}
function _hideErrorMsg(field) {
  var fieldContainer = tools.getClosest(field, ".".concat(_field["default"]["class"]));
  var errorMsg = fieldContainer.querySelector('.js-form-error');
  if (errorMsg) {
    field.removeAttribute('aria-describedby');
    fieldContainer.removeChild(errorMsg);
  }
}
function _makeError(field, message) {
  var cssClass = "".concat(field.dataset.errorWrapper || '', " js-form-error");
  field.setAttribute('aria-describedby', "".concat(field.id, "-error"));
  var tpl = "<span class=\"".concat(_field["default"]["class"]).concat(_field["default"].error, " ").concat(cssClass, "\" id=\"").concat(field.id, "-error\">").concat(message, "</span>");
  return tpl;
}
function handleSocialLoginError() {
  var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var errorStatus = document.querySelector('#social_provider_error');
  if (force || errorStatus && errorStatus.textContent === 'true') {
    var provider = document.querySelector('#social_provider_in_error').textContent;
    document.querySelector(".js-social-login-error").classList.remove('kl-hidden');
    (0, _trackingEvents.onPageError)("user cancelled social provider login or signup" + "|" + provider);
  }
}

/**
 * Capitalizes the first letter of a string.
 */
function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
var PasswordInput = /*#__PURE__*/function () {
  function PasswordInput(domField, domPasswordForm) {
    (0, _classCallCheck2["default"])(this, PasswordInput);
    if (!domField || !domPasswordForm) {
      throw new Error('Both domField and domPasswordForm are required');
    }
    this.input = domField.querySelector('input');
    this.togglePasswordButtons = domPasswordForm.querySelectorAll('.mc-password-input__button');
    this.domForgotPassword = domPasswordForm.querySelector('.js-forgot-password');
    if (!this.input) {
      throw new Error('No input field found in domField');
    }
    this.timer = null;
    this.forceBlur = false;
    this.initTogglePassword();
    this.initBlurWorkaround();
    this.initForgotPasswordEvent();
  }
  return (0, _createClass2["default"])(PasswordInput, [{
    key: "initTogglePassword",
    value: function initTogglePassword() {
      var _this2 = this;
      this.togglePasswordButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          if (_this2.input.type === 'password') {
            _this2.showPassword(button);
          } else {
            _this2.hidePassword(button);
          }
        });
      });
    }
  }, {
    key: "showPassword",
    value: function showPassword(button) {
      this.input.type = 'text';
      button.textContent = button.getAttribute('data-label-hide');
    }
  }, {
    key: "hidePassword",
    value: function hidePassword(button) {
      this.input.type = 'password';
      button.textContent = button.getAttribute('data-label-show');
    }
  }, {
    key: "initBlurWorkaround",
    value: function initBlurWorkaround() {
      var _this3 = this;
      var blurHandler = function blurHandler(e) {
        if (!_this3.forceBlur) {
          clearTimeout(_this3.timer);
          e.stopImmediatePropagation();
          _this3.timer = setTimeout(function () {
            _this3.forceBlur = true;
            _this3.input.dispatchEvent(new Event('blur', {
              bubbles: true
            }));
          }, 100);
        }
        _this3.forceBlur = false;
      };
      this.input.addEventListener('blur', blurHandler, true);
    }
  }, {
    key: "initForgotPasswordEvent",
    value: function initForgotPasswordEvent() {
      var _this4 = this;
      var forgotPasswordHandler = function forgotPasswordHandler(e) {
        if (e.target === _this4.domForgotPassword) {
          (0, _tms.hitEventTms)(_this4.domForgotPassword, _trackingEvents.cdlEvent, JSON.stringify(_trackingEvents.forgotPasswordEvent));
          clearTimeout(_this4.timer);
        }
      };
      document.addEventListener('click', forgotPasswordHandler, true);

      // Cleanup to avoid memory leaks
      window.addEventListener('unload', function () {
        document.removeEventListener('click', forgotPasswordHandler, true);
      });
    }
  }]);
}();
var Loader = /*#__PURE__*/function () {
  function Loader(selector) {
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5000;
    (0, _classCallCheck2["default"])(this, Loader);
    this.timeout = timeout;
    this.loader = document.querySelector(selector);
    var loaderObj = new _genericalLoader["default"]();
    loaderObj.append(this.loader);
  }
  return (0, _createClass2["default"])(Loader, [{
    key: "show",
    value: function show() {
      var _this5 = this;
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        _this5.hide();
      }, this.timeout);
      this.loader.classList.add('open');
    }
  }, {
    key: "hide",
    value: function hide(fn) {
      clearTimeout(this.timer);
      this.loader.classList.remove('open');
      if (fn) {
        fn();
      }
    }
  }]);
}();
var toQueryString = function toQueryString(params) {
  var queryString = Object.keys(params).map(function (key) {
    return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(params[key]));
  }).join('&');
  return queryString;
};
es6promise.polyfill();
var values = require('object.values');
if (!Object.values) {
  values.shim();
}
var EmailForm = /*#__PURE__*/function () {
  function EmailForm(domEmailForm, onEmailChange, signUp, loader, loginOrigin) {
    var _this$domEmailForm$qu;
    (0, _classCallCheck2["default"])(this, EmailForm);
    this.domEmailForm = domEmailForm;
    this.form = new _forms.Formulaire(domEmailForm);
    this.domEmailInput = this.domEmailForm.querySelector('.js-email-field input');
    this.emailErrorText = (_this$domEmailForm$qu = this.domEmailForm.querySelector('.js-form-missing-error-text')) === null || _this$domEmailForm$qu === void 0 ? void 0 : _this$domEmailForm$qu.innerHTML;

    // Initialize validation and events
    setupEmailValidation(this.domEmailInput);
    this.focusEmailInput();
    this.trackEmailFormDisplay(loginOrigin);
    this.setupFormSubmit(onEmailChange, signUp, loader, loginOrigin);
    (0, _trackingEvents.onPageDisplay)("enter email", "My Account", "login");
  }

  /**
   * Focus on the email input field when the form loads.
   */
  return (0, _createClass2["default"])(EmailForm, [{
    key: "focusEmailInput",
    value: function focusEmailInput() {
      if (this.domEmailInput) {
        this.domEmailInput.focus();
      }
    }

    /**
     * Tracks the form display event.
     */
  }, {
    key: "trackEmailFormDisplay",
    value: function trackEmailFormDisplay(loginOrigin) {
      (0, _tms.hitEventTms)(this.domEmailForm, _trackingEvents.cdlEvent, JSON.stringify((0, _trackingEvents.loginEmailFormDisplayEvent)(loginOrigin === 'tempo')));
    }

    /**
     * Sets up the form submit event.
     */
  }, {
    key: "setupFormSubmit",
    value: function setupFormSubmit(onEmailChange, signUp, loader, loginOrigin) {
      var _this6 = this;
      this.domEmailForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = _this6.domEmailInput.value.trim();
        if (!email) {
          _turnInvalid(_this6.domEmailInput, _this6.emailErrorText);
          return;
        }
        var _this6$domEmailForm$d = _this6.domEmailForm.dataset,
          process = _this6$domEmailForm$d.process,
          collab_login_url = _this6$domEmailForm$d.collab_login_url;
        loader.show();
        lm.fetch({
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          url: '/services/account/check',
          body: JSON.stringify({
            email: email
          }),
          success: function success(data) {
            return _this6.handleSuccess(data, email, process, collab_login_url, onEmailChange, signUp, loginOrigin, loader);
          },
          error: function error() {
            loader.hide();
          }
        });
      });
    }

    /**
     * Handles a successful form submission.
     */
  }, {
    key: "handleSuccess",
    value: function handleSuccess(data, email, process, collabLoginUrl, onEmailChange, signUp, loginOrigin, loader) {
      loader.hide();
      var result;
      try {
        result = JSON.parse(data);
      } catch (error) {
        console.error('Invalid JSON response:', error);
        return;
      }
      (0, _tms.hitEventTms)(this.domEmailForm.querySelector('[type="submit"]'), _trackingEvents.cdlEvent, JSON.stringify((0, _trackingEvents.submitEmailEvent)(loginOrigin === 'tempo')));
      cleanNotifications();
      switch (result.authType) {
        case AUTH_TYPE.CLIENT:
          onEmailChange(email);
          break;
        case AUTH_TYPE.CLIENT_COLLAB:
          onEmailChange(email, true);
          break;
        case AUTH_TYPE.COLLAB:
          if (process === 'lmpartner') {
            signUp(this.domEmailForm, email);
          } else {
            document.location.replace(collabLoginUrl);
          }
          break;
        default:
          console.warn('Unknown auth type:', result.authType);
      }
    }
  }]);
}();
var PasswordForm = exports.PasswordForm = /*#__PURE__*/function () {
  function PasswordForm(domPasswordForm, onEmailEdit, loader, loginOrigin) {
    var _domPasswordForm$quer,
      _this7 = this;
    (0, _classCallCheck2["default"])(this, PasswordForm);
    this.domPasswordForm = domPasswordForm;
    this.form = new _forms.Formulaire(domPasswordForm);
    this.loader = loader;
    this.loginOrigin = loginOrigin;

    // Select important DOM elements
    this.domPasswordField = domPasswordForm.querySelector('.js-password-field');
    this.domPasswordFieldInput = this.domPasswordField.querySelector('input');
    this.domEmailFieldInput = domPasswordForm.querySelector('.js-email-field .js-form-input');
    this.missingErrorText = (_domPasswordForm$quer = domPasswordForm.querySelector('.js-form-missing-error-text')) === null || _domPasswordForm$quer === void 0 ? void 0 : _domPasswordForm$quer.innerHTML;

    // Error message for password validation
    this.passwordErrorText = domPasswordForm.querySelector('.js-form-password-error-text').innerHTML;

    // Initialize password and email input validation
    this.initValidation();

    // Bind the form submit event
    this.domPasswordForm.addEventListener('submit', function (e) {
      return _this7.handleSubmit(e);
    });
  }
  return (0, _createClass2["default"])(PasswordForm, [{
    key: "initValidation",
    value: function initValidation() {
      // Setup password input component
      new PasswordInput(this.domPasswordField, this.domPasswordForm);

      // Add validation for email and password fields
      setupEmailValidation(this.domEmailFieldInput);
      setupPasswordValidation(this.domPasswordField);
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(e) {
      var _this8 = this;
      e.preventDefault();
      var formData = new FormData(this.domPasswordForm);
      var _this$domPasswordForm = this.domPasswordForm.dataset,
        client_id = _this$domPasswordForm.client_id,
        scope = _this$domPasswordForm.scope,
        state = _this$domPasswordForm.state,
        redirect_uri = _this$domPasswordForm.redirect_uri,
        nonce = _this$domPasswordForm.nonce,
        r5_base_url = _this$domPasswordForm.r5_base_url;
      var email = this.domEmailFieldInput.value.trim();
      var password = this.domPasswordFieldInput.value.trim();
      if (!email) {
        _turnInvalid(this.domEmailFieldInput, this.missingErrorText);
        return;
      }
      if (!password) {
        _turnInvalid(this.domPasswordField, this.missingErrorText);
        _inputIncorrect(this.domPasswordFieldInput);
        return;
      }
      this.loader.show();
      var requestData = _objectSpread({
        client_id: client_id,
        scope: scope,
        email: email,
        password: password
      }, nonce && {
        nonce: nonce
      });

      // Make the API call
      lm.fetch({
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        url: "".concat(r5_base_url).concat(signInPath),
        body: JSON.stringify(requestData),
        success: function success(response) {
          return _this8.handleSuccess(response, {
            client_id: client_id,
            scope: scope,
            state: state,
            redirect_uri: redirect_uri,
            nonce: nonce,
            r5_base_url: r5_base_url
          });
        },
        error: function error() {
          return _this8.handleError();
        }
      });
    }
  }, {
    key: "handleSuccess",
    value: function handleSuccess(response, _ref) {
      var client_id = _ref.client_id,
        scope = _ref.scope,
        state = _ref.state,
        redirect_uri = _ref.redirect_uri,
        nonce = _ref.nonce,
        r5_base_url = _ref.r5_base_url;
      (0, _tms.hitEventTms)(this.domPasswordForm.querySelector('[type="submit"]'), _trackingEvents.cdlEvent, JSON.stringify((0, _trackingEvents.formSubmitEvent)(this.loginOrigin === 'tempo')));
      var result = JSON.parse(response);
      var callbackParams = _objectSpread({
        client_id: client_id,
        response_type: 'code',
        scope: scope,
        state: state,
        redirect_uri: redirect_uri,
        tkn: result.tkn
      }, nonce && {
        nonce: nonce
      });
      var callbackUrl = "".concat(r5_base_url).concat(callbackPath, "?").concat(toQueryString(callbackParams));
      window.location.replace(callbackUrl);
    }
  }, {
    key: "handleError",
    value: function handleError() {
      this.loader.hide();
      // Clear the password field
      this.domPasswordFieldInput.value = '';
      _turnInvalid(this.domPasswordField, this.passwordErrorText);
      _inputIncorrect(this.domPasswordFieldInput);
      (0, _trackingEvents.onPageError)("incorrect password");
    }
  }, {
    key: "setEmail",
    value: function setEmail(email) {
      this.domEmailFieldInput.value = email;
      var url = this.domPasswordForm.querySelector('.js-forgot-password').href;
      var urlObj = new URL(url);
      urlObj.searchParams.set('email', email);
      this.domPasswordForm.querySelector('.js-forgot-password').href = urlObj.toString();
      _inputCorrect(this.domEmailFieldInput);
    }
  }]);
}();
var selectButtonClass = 'm-login-form__context-button--selected';
var ContextForm = /*#__PURE__*/(0, _createClass2["default"])(function ContextForm(domContextForm, onContextChange) {
  var _this9 = this;
  (0, _classCallCheck2["default"])(this, ContextForm);
  this.domContextForm = domContextForm;
  var domSubmitButton = domContextForm.querySelector('.js-login-context-submit');
  var domContextButtons = domContextForm.querySelectorAll('.js-login-context-button');
  domSubmitButton.disabled = true;
  domContextButtons.forEach(function (button) {
    button.addEventListener('click', function (e) {
      domContextButtons.forEach(function (item) {
        item.classList.remove(selectButtonClass);
      });
      e.target.classList.add(selectButtonClass);
      _this9.context = e.target.dataset.value;
      domSubmitButton.disabled = false;
    });
  });
  domContextForm.addEventListener('submit', function (e) {
    e.preventDefault();
    onContextChange(_this9.context);
  });
});
var LoginForm = /*#__PURE__*/function (_lm$Composant) {
  function LoginForm() {
    var _this10;
    (0, _classCallCheck2["default"])(this, LoginForm);
    _this10 = _callSuper(this, LoginForm);
    var loginLoader = new Loader('.js-login-form-loading');
    _this10.domContainer = document.querySelector('.js-login-form-container');
    _this10.onEmailEdit = _this10.onEmailEdit.bind(_this10);
    _this10.showPassword = _this10.showPassword.bind(_this10);
    var login = _this10.domContainer.dataset.login;
    new SocialLoginForm(loginLoader);
    _this10.passwordForm = new PasswordForm(document.querySelector('form#js-password-form'), _this10.onEmailEdit, loginLoader, login);
    _this10.contextForm = new ContextForm(document.querySelector('form#js-context-form'), function (context) {
      if (context === 'collaborator') {
        var collab_login_url = _this10.domContainer.dataset.collab_login_url;
        document.location.replace(collab_login_url);
      } else {
        _this10.showPassword(login);
      }
    });
    var onEmailChange = function onEmailChange(email, isCollaborator) {
      _this10.passwordForm.setEmail(email);
      if (isCollaborator) {
        _this10.passwordForm.domPasswordForm.classList.add('kl-hidden');
        _this10.contextForm.domContextForm.classList.remove('kl-hidden');
        _this10.emailForm.domEmailForm.classList.add('kl-hidden');
      } else {
        _this10.showPassword(login);
      }
    };
    var signUp = function signUp(domEmailForm, emailNotEncoded) {
      var _domEmailForm$dataset = domEmailForm.dataset,
        signup_url = _domEmailForm$dataset.signup_url,
        process = _domEmailForm$dataset.process,
        redirect = _domEmailForm$dataset.redirect,
        state = _domEmailForm$dataset.state,
        nonce = _domEmailForm$dataset.nonce;
      var email = encodeURIComponent(emailNotEncoded);
      var params = {
        process: process,
        redirect: redirect,
        email: email,
        state: state,
        nonce: nonce
      };
      var urlParams = Object.keys(params).filter(function (key) {
        return !!params[key];
      }).map(function (key) {
        return "".concat(key, "=").concat(params[key]);
      }).join('&');
      var signUpLink = signup_url + (urlParams.length ? "?".concat(urlParams) : '');
      document.location.href = signUpLink;
    };
    _this10.emailForm = new EmailForm(document.querySelector('form#js-email-form'), onEmailChange, signUp, loginLoader, login);
    return _this10;
  }
  (0, _inherits2["default"])(LoginForm, _lm$Composant);
  return (0, _createClass2["default"])(LoginForm, [{
    key: "showPassword",
    value: function showPassword(loginOrigin) {
      (0, _trackingEvents.onPageDisplay)("enter password", "My Account", "login");
      (0, _tms.hitEventTms)(window, _trackingEvents.cdlEvent, JSON.stringify((0, _trackingEvents.loginPasswordFormDisplayEvent)(loginOrigin === 'tempo')));
      this.passwordForm.domPasswordForm.classList.remove('kl-hidden');
      this.contextForm.domContextForm.classList.add('kl-hidden');
      this.emailForm.domEmailForm.classList.add('kl-hidden');
      this.passwordForm.domPasswordFieldInput.focus();
    }
  }, {
    key: "onEmailEdit",
    value: function onEmailEdit() {
      this.passwordForm.domPasswordForm.classList.add('kl-hidden');
      this.contextForm.domContextForm.classList.add('kl-hidden');
      this.emailForm.domEmailForm.classList.remove('kl-hidden');
    }
  }]);
}(lm.Composant);
var SocialLoginForm = /*#__PURE__*/function () {
  function SocialLoginForm(loader) {
    var _this11 = this;
    (0, _classCallCheck2["default"])(this, SocialLoginForm);
    this.loader = loader;
    document.addEventListener('click', function (event) {
      var link = event.target.closest('.social-button');
      if (!link) return;
      var provider = _this11.getProviderFromId(link.id);
      if (!provider) return;
      var form = link.closest('form');
      if (!form) {
        console.error('No parent form found for social login.');
        return;
      }
      _this11.handleSocialLogin(provider, link, form);
    });
  }
  return (0, _createClass2["default"])(SocialLoginForm, [{
    key: "handleSocialLogin",
    value: function handleSocialLogin(provider, link, form) {
      var providerName = capitalizeFirstLetter(provider);
      (0, _tms.hitEventTms)(link, _trackingEvents.cdlEvent, JSON.stringify((0, _trackingEvents.loginByProviderEvent)(providerName)));
      callSocialLoginBack(SocialLoginProvider[provider.toUpperCase()], form, this.loader);
    }
  }, {
    key: "getProviderFromId",
    value: function getProviderFromId(id) {
      switch (id) {
        case 'js-google-provider':
          return 'google';
        case 'js-facebook-provider':
          return 'facebook';
        case 'js-apple-provider':
          return 'apple';
        default:
          return null;
      }
    }
  }]);
}();
var SocialLoginProvider = /*#__PURE__*/function () {
  function SocialLoginProvider() {
    (0, _classCallCheck2["default"])(this, SocialLoginProvider);
  }
  return (0, _createClass2["default"])(SocialLoginProvider, null, [{
    key: "GOOGLE",
    get: function get() {
      return 'google';
    }
  }, {
    key: "FACEBOOK",
    get: function get() {
      return 'facebook';
    }
  }, {
    key: "APPLE",
    get: function get() {
      return 'apple';
    }
  }]);
}();
function callSocialLoginBack(provider, dom, loader) {
  console.log('Social login back-end call:', provider);
  var state = dom.dataset.state;
  loader.show();
  lm.fetch({
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    url: '/services/socialLogin/login?state=' + state,
    body: JSON.stringify({
      provider: provider
    }),
    success: function success(redirectUrl) {
      window.location.replace(redirectUrl);
      loader.hide();
    },
    error: function error(err) {
      console.error(err);
      handleSocialLoginError(true);
      loader.hide();
    }
  });
  return false;
}
lm.DOMReady(function () {
  new LoginForm();
  handleSocialLoginError();
});